import Padlock from '@svg/lock.svg?react';
import CustomButton from '../../shared/custom-button/custom-button';
import { Link } from 'react-router-dom';

export const InternalErrorMessage = () => {
    return (
        <div className="unauthorized-body">
            <div className="unauthorized-content">
                <div className="unauthorized-icon-background">
                    <Padlock/>
                </div>
                <div className="unauthorized-message">You are unauthorized to access</div>
                <div className="unauthorized-message">this service</div>
            </div>
            <div className="btn-wrapper">
                <Link
                    to={`https://halo-access.web.att.com/identityiq/plugins/pluginPage.jsf?pn=HaloAccess#/createRequest`}
                    target="_blank" rel="noreferrer" className={'halo-access-link'}>
                    <CustomButton label={'Request Access'} className="primary-btn action-btn"/>
                </Link>
            </div>
        </div>
    );
};